export default "__VITE_PUBLIC_ASSET__0ad19099__"